
<script>import { Σ } from "../../common/clsx/index";
import { writable } from "svelte/store";
import { setContext } from "../../common/svelte/index";
export let defaultSelected = "";
export let mode = "vertical";
export let className = "";
let selectedStore = writable(defaultSelected);
setContext("selected", selectedStore);

$: {
  $selectedStore = defaultSelected;
}

const state = {};
state.style = Σ("el-menu", `el-menu--${mode}`, className);</script>


<ul class={state.style} style={`border-bottom: none`}>
        <slot />
    </ul>


<style>

</style>